<script>
import { mapState } from 'vuex'


export default {
  name: 'ConfirmDialog',
  computed: {
    ...mapState({
      confirmDialog: state => state.ui.confirmDialog,
    })
  },
  methods: {
    async confirm() {
      await this.$store.dispatch(this.confirmDialog.action, this.confirmDialog.data)
      if(this.confirmDialog.nextTickAction) {
        this.$nextTick(async () => {
          await this.$store.dispatch(this.confirmDialog.nextTickAction, this.confirmDialog.nextTickData)
          this.$store.dispatch('ui/CLOSE_CONFIRM_DIALOG')
        })
      }
      else {
        this.$store.dispatch('ui/CLOSE_CONFIRM_DIALOG')
      }
    }
  }
}
</script>

<template>
  <v-dialog
      v-if="confirmDialog.show"
      v-model="confirmDialog.show"
      persistent
      no-click-animation
      width="600"
      max-width="75%"
    >

      <v-card tile class="pa-8" >
        <v-card-title>
          <h1 class="pb-0 heading" v-html="confirmDialog.header" />
        </v-card-title>
        <v-card-text>
          <div v-html="confirmDialog.message"></div>
        </v-card-text>
        <v-card-actions class="pl-6">
          <v-btn class="megaButton my-0 primary" x-large @click="confirm">Confirm</v-btn>
          <v-btn class="megaButton my-0 secondary" x-large @click="$store.dispatch('ui/CLOSE_CONFIRM_DIALOG')">Cancel</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
</template>

<style scoped lang="scss">
  .heading {
    font-size: 28px !important;
    line-height: 30px;
    color: var(--v-primary-base);
    font-weight: bold;
    text-transform: uppercase;
  }
  .subdetail {
    color: var(--v-secondary-base);;
    position: relative;
    font-size: 14px;
    top: -5px;
  }
</style>
